import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import SearchInput from 'components/SearchInput'
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import SimpleSelect from 'components/SimpleSelect';
import ProcedureStatus from 'constants/ProcedureStatus';

const style = theme => ({
    root: {
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(1),

        '&>*:not(:first-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    search: {
        ...theme.components.input.search
    },
    chipsGrid: {
        marginTop: theme.spacing(1)
    },
    select: {
        width: 250,
    }
})

function SearchBar(
    {
        classes,
        setFilters,
        filters,
    }) {

    return (
        <>
            <GridBlock
                alignItems='flex-end'
                className={classes.root}
            >
                <SearchInput
                    id='search'
                    label={Tr('search')}
                    className={classes.search}
                />
                <SimpleSelect
                    label={Tr('status')}
                    className={classes.select}
                    items={ProcedureStatus}
                    onChange={(e) => setFilters({state: e.target.value})}
                    value={filters.state}
                />
            </GridBlock>
        </>
    )
}

SearchBar.propTypes = {
    classes: PropTypes.any,
}

SearchBar.defaultProps = {}

export default withStyles(style)(SearchBar);